// extracted by mini-css-extract-plugin
module.exports = {"trophy":"trophy_trophy__veBPx","trophy-1":"trophy_trophy-1__13fR4","trophy-2":"trophy_trophy-2__YY8vH","trophy-3":"trophy_trophy-3__2gH10"};